export const styleHalfInputWrapper = `
    width:48%;

`
